import { render, staticRenderFns } from "./studentOffer.vue?vue&type=template&id=a6c10ffe&"
import script from "./studentOffer.vue?vue&type=script&lang=js&"
export * from "./studentOffer.vue?vue&type=script&lang=js&"
import style0 from "./studentOffer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports